// dependencies
import { CreateProcess } from "redux-process";

import serializeObject from "../../utils/SerializeObject";

export const reviewAssignmentsGetInfo = CreateProcess({
	method: "GET",
	name: "getAssignments",
	type: "REVIEWASSIGNMENTS:GETINFO",

	request: (props) => {
		const queryParams = serializeObject(props.params);

		return {
			url: `/api/company/reviews/overview/?${queryParams}`,
		};
	},

	success: (response) => {
		const { data } = response;
		const { count, assignments } = data;

		return {
			assignments,
			count,
		};
	},
});
